import { action, makeObservable, observable } from "mobx"

import { currentEpochNumber } from "@/domains/library/dates"

export interface HeroEmissionsAnalyticsSeries {
  readonly data?: readonly number[]
}

export interface HeroEmissionsAnalyticsData {
  readonly series?: readonly HeroEmissionsAnalyticsSeries[]
}

/**
 * Holds V4 emissions analytics fetched for the landing hero.
 * Used as a fallback when epoch repository / orchestrator data is not yet available.
 */
export class HeroEmissionsStore {
  analytics: HeroEmissionsAnalyticsData | null = null

  constructor() {
    makeObservable(this, {
      analytics: observable,
      updateFromAnalytics: action,
    })
  }

  updateFromAnalytics(data: HeroEmissionsAnalyticsData): void {
    this.analytics = data
  }

  /** Epoch gauges mint from analytics series; null when unavailable. */
  getEpochGaugesMint(chainSlug: string): number | null {
    const epochNumber = currentEpochNumber({ chainSlug })
    const raw = this.analytics?.series?.[1]?.data?.[epochNumber - 1]

    if (raw == null) {
      return null
    }

    const mint = typeof raw === "number" ? raw : parseFloat(String(raw))
    return Number.isFinite(mint) ? mint : null
  }
}
